// extracted by mini-css-extract-plugin
export var contentWrapper = "SimpleMobileNewsSection-module--contentWrapper--20cd9";
export var eachSlideEffect = "SimpleMobileNewsSection-module--eachSlideEffect--789cd";
export var newsImageHolder = "SimpleMobileNewsSection-module--newsImageHolder--a5a3f";
export var sliderWrapper = "SimpleMobileNewsSection-module--sliderWrapper--f63b1";
export var title = "SimpleMobileNewsSection-module--title--c89ac";
export var titleWrapper = "SimpleMobileNewsSection-module--titleWrapper--788dc";
export var wrapper = "SimpleMobileNewsSection-module--wrapper--f52e4";